import {CloudName, CloudType, Environment} from '@q9elements/ui-kit/common';

export const environment: Environment = {
    production: true,
    CLOUD_TYPE: CloudType.PUBLIC,
    CLOUD_NAME: CloudName.ELEMENTS, 
    ENV: 'production',      
    version: require('../../package.json').version,
    MAIN_APP_URL: 'https://app-green.q9elements.com',
    API_STATIC_FILE_UPLOAD: 'https://upload.q9elements.com:1443/api',
    CHANGELOG_APP_URL: 'https://changelogs-green.q9elements.com',
    API_ENDPOINT: 'https://api-green.q9elements.com:8443/api/v1', 
    REMOTE_UNLOCK_TTL: 600000,
    TEAM_APP: 'https://spacemgt-green.q9elements.com',
    RELEASE_URL: 'https://releasemgt-green.q9elements.com',
    REPORTS_API_ENDPOINT: 'https://gateway.q9elements.com/report/api/v1',
    REF_MODEL_APP: 'https://refmodel-green.q9elements.com',
    REPORTS_APP: 'https://report-green.q9elements.com',
    MAP_MANAGEMENT_APP: 'https://mapmgt-green.q9elements.com',
    INTERCOM_APP_ID: 'c2s7te3m',
    DOMAIN: 'q9elements.com',
    SECURE_COOKIES: true,
    SENTRY_AUTH_TOKEN: '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',
    SENTRY_DSN: '',
    SENTRY_ORG: 'q9-elements-ltd',
    SENTRY_PROJECT: 'diagram-app',
    DIAGRAM_URL: 'https://diagram-green.q9elements.com',
    NOUI: false,
    DATA_STRUCTURE_URL: 'https://datatable-green.q9elements.com',
    SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2Usdv0kmAXCXN7jNx.bxrXbMIR46h1q6AsNtluiXy9tUjXwhgDczWNbzABIUSr42',
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    JAM_TEAM_ID: '2c0904d3-adca-4b6c-abae-7682857656f5',
    MCP_OAUTH_URL: 'https://api-green.q9elements.com:8443/api/v1/oauth',
    fbConfig: {
        apiKey:'AIzaSyBeWiMjG2HLbyjfPkEhH0HC3aMxu3BbSwg',
        authDomain:'elements-prod.firebaseapp.com',
        databaseURL: 'https://elements-prod.firebaseio.com/',
        projectId: 'elements-prod',
        appId: '1:446942151320:web:1df47b44ac10e9ccd0c6ed'
    }
};
